// src/App.tsx
import { ThemeProvider, theme } from "@primer/react";
import deepmerge from "deepmerge";
import { useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import BaseStyles from "./BaseStyles";
import { LazyPage } from "./components-ui/loadable";
import { CommonProvider } from "./contexts/common";
import { HubProvider } from "./contexts/HubProvider";
import { useAppDispatch } from "./hooks/useAppDispatch";
import { useAppSelector } from "./hooks/useAppSelector";
import * as authReducer from "./faetures/auth/authSlice";

// ✅ Shell layout mới (rail + menu + topbar + workspace)
import AppShell from "./layout/AppShell/AppShell";

const AuthorizedContent = LazyPage(import("./router/AuthorizedContent"));
const UnAuthorizedContent = LazyPage(import("./router/UnAuthorizedContent"));

const customTheme = deepmerge(
    {
        ...theme,
        fontSizes: [
            "11px",
            "13px",
            "16px",
            "20px",
            "24px",
            "32px",
            "40px",
            "48px",
            "56px"
        ]
    },
    {
        colorSchemes: {
            light: {
                colors: {
                    accent: {
                        fg: "#DE3F0F",
                        emphasis: "#DE3F0F"
                    },
                    btn: {
                        primary: {
                            bg: "#DE3F0F",
                            focusBg: "#DE3F0F",
                            hoverBg: "#DE3F0F",
                            selectedBg: "#DE3F0F",
                            disabledBg: "rgba(222, 63, 15,0.6)"
                        }
                    }
                }
            }
        }
    }
);

function App() {
    const dispatch = useAppDispatch();
    const { isAuthenticated } = useAppSelector((state) => state.auth);

    useEffect(() => {
        const persistedAuth = localStorage.getItem("auth");
        if (!persistedAuth) return;

        try {
            const authData = JSON.parse(persistedAuth);

            dispatch(
                authReducer.loginSuccess({
                    payload: {
                        token_info: {
                            access_token: authData.accessToken,
                            refresh_token: authData.refreshToken
                        },
                        profile: authData.user
                    },
                    type: ""
                })
            );
        } catch (error) {
            console.error("Failed to parse auth data from localStorage", error);
        }
    }, [dispatch]);

    return (
        <Router>
            <CommonProvider>
                <ThemeProvider theme={customTheme} colorMode={"auto"}>
                    <BaseStyles>
                        <Toaster
                            position="top-right"
                            toastOptions={{ duration: 4000 }}
                            reverseOrder={false}
                        />

                        {isAuthenticated ? (
                            <HubProvider>
                                {/* ✅ Bọc toàn bộ phần sau đăng nhập vào khung mới */}
                                <AppShell>
                                    <AuthorizedContent />
                                </AppShell>
                            </HubProvider>
                        ) : (
                            <UnAuthorizedContent />
                        )}
                    </BaseStyles>
                </ThemeProvider>
            </CommonProvider>
        </Router>
    );
}

export default App;
